import { Button, Link } from "@chakra-ui/react";

interface LinkButtonProps {
	label: string;
	link?: string;
	onClick?: () => void;
}

export const LinkButton = (props: LinkButtonProps) => {
	const { label, link, onClick } = props;
	return (
		<Button
			fontSize="lg"
			href={link}
			variant="unstyled"
			onClick={onClick}
			as={link ? Link : undefined}
			_hover={{ color: "brand.contrast", textDecoration: "none" }}
		>
			{label}
		</Button>
	);
};
